// extracted by mini-css-extract-plugin
export default {"table-container":"style_table-container__s6Hzw","note":"style_note__fBA+z"};